import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { lastValueFrom } from 'rxjs';

import { Types } from '../../domain/types.domain';
import { City } from '../../domain/city/entities/city.entity';
import { CityRepositoryInterface } from '../../domain/city/interfaces/repositories/city.repository.interface';
import { PublicCityListItem } from '../../domain/city/dtos/get-public-city-list.output';

@Injectable()
export class CityHttpRepository implements CityRepositoryInterface {
  private readonly _http = inject(HttpClient);
  private readonly _settings = inject(Types.Settings);

  async getPublicList(): Promise<PublicCityListItem[]> {
    return lastValueFrom(
      this._http.get<PublicCityListItem[]>(`${this._settings.citiesUrl.v1}/public/list`)
    );
  }

  async getByIndex(index: number): Promise<City> {
    return lastValueFrom(
      this._http.get<City>(`${this._settings.citiesUrl.v1}/index/${index}`)
    );
  }

  async getByIdentity(identity: string): Promise<City> {
    const cityProjection = [
      'active',
      'address',
      'alternativeAuthFields',
      'applicationLink',
      'cidade',
      'connection',
      'emailBranding',
      'estado',
      'faviconUrl',
      'hideModalRecaptcha',
      'identidade',
      'index',
      'internal',
      'loginUrl',
      'logo',
      'options',
      'signUpConfig',
      'tel',
      'textLogin',
      'title',
      'urlImageLogin',
      'useIntercom',
      'users',
    ];

    return lastValueFrom(
      this._http.get<City>(
        `${this._settings.citiesUrl.v1}/identity/${identity}`,
        {
          params: {
            projection: cityProjection.join(','),
          },
        }
      )
    );
  }
}
